export class ProjectsParams {
    public root: boolean;
    public startDate?: Date;
    public endDate?: Date;
    public groupBy?: string;

    constructor() {
        this.root = false;
    }
}
